export default {
  boxShadow: '0 0 11px rgba(33, 33, 33, 0.2)',
  hrBoxShadow: '2px 0px 2px #f4f4f4',
  elFocus: '0 0 0 2px rgba(24, 144, 255, 0.2)'
};
